import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  height: 100%;

  @media (max-width: 767px) {
        width: 80%;
        margin: 0 auto;
        justify-content: start;
    }
`;

export const Header = styled.h1`
  font-size: 2rem;
  margin: 0;
  color: #333;
`;

export const Text = styled.p`
  font-size: 1.2rem;
  color: #666;
`;
